import { useMemo } from 'react';

import { useOnboardingUserInfo } from 'src/hooks/use-onboarding-user-info';
import { Org } from 'src/interfaces/onboarding.types';

interface State {
  activeOrgs: Org[];
  hasActiveOrg: boolean;
  schools: Org[];
  districts: Org[];
}

export const useUserOrgs = () => {
  const { data: onboardingUserInfo, isLoading } = useOnboardingUserInfo();

  const state: State = useMemo(() => {
    if (!onboardingUserInfo)
      return {
        activeOrgs: [],
        hasActiveOrg: false,
        schools: [],
        districts: [],
      };

    const userOrgs = onboardingUserInfo.orgs;

    // search district org among all user orgs as it doesn't have status
    const districts = userOrgs.filter((org) => org.orgType === 'district');

    const activeOrgs = userOrgs.filter((org) => org.orgStatus === 'active');

    // Additional check to filter districts with no active schools
    const hasActiveOrg = !!userOrgs.filter(
      (org) =>
        org.orgStatus === 'active' &&
        (org.userOrgStatus === 'active' || org.orgType !== 'district'),
    ).length;

    // School should be active
    const schools = activeOrgs.filter((org) => org.orgType === 'school');

    return {
      activeOrgs,
      hasActiveOrg,
      schools,
      districts,
    };
  }, [onboardingUserInfo]);

  return { ...state, isLoading };
};
